import React from 'react';
import { RotatingLines } from  'react-loader-spinner'

function Loader() {

    return (
        <div data-testid="loader-spinner">
            <RotatingLines
                strokeColor="grey"
                strokeWidth="3"
                animationDuration="0.75"
                width="70"
                visible={true}
                />
        </div>
    )
}

export default Loader;